export default __webpack_public_path__ + "3e1bf05335c8b8f7906bc3fe5adfb6af.jpg";